import { institutionRole } from '../enums/institutionRole';

export const isEarlyStudent = institutionProfile =>
  institutionProfile.institutionRoles.includes(institutionRole.EARLY_STUDENT);
